<template>
  <div>
    <b-card no-body>
      <template v-if="userData.packageLimits[16].limit > 0">
        <b-card-body class="text-right">
          <b-button
            variant="primary"
            :to="$route.path + '/add'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </b-card-body>
        <template v-if="dataList.length > 0">
          <b-table
            responsive="sm"
            :fields="fields"
            :items="dataList"
            striped
          >
            <template #cell(title)="data">
              {{ data.item.title }}
              <div
                v-if="data.item.categories || data.item.products"
                class="mt-1"
              >
                <small class="badge badge-light-primary mr-1">{{ data.item.categories }}</small>
                <small class="badge badge-light-info">{{ data.item.products }}</small>
              </div>
            </template>
            <template #cell(sdate)="data">
              <div v-if="data.item.sdate">
                <small class="badge badge-sm badge-light-success">{{ moment(data.item.sdate).format('DD.MM.YYYY') }}</small>
                -
                <small class="badge badge-sm badge-light-danger">{{ moment(data.item.edate).format('DD.MM.YYYY') }}</small>
              </div>
            </template>
            <template #cell(created)="data">
              {{ data.item.username }}
              <div v-if="data.item.created">
                <small class="text-muted">{{ moment(data.item.created).format('DD.MM.YYYY') }}</small>
              </div>
            </template>
            <template #cell(control)="data">
              <div class="text-right">
                <list-buttons
                  :edit-action="$route.path + '/edit/' + data.item.id"
                  :delete-action="removeData"
                  :data-id="data.item.id"
                />
              </div>
            </template>
          </b-table>
          <b-card-footer>
            <b-pagination
              v-model="currentPage"
              :total-rows="dataCounts"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-card-footer>
        </template>
        <b-alert
          v-else
          variant="info"
          class="m-2 text-center"
          show
        >
          <div class="alert-body">
            <feather-icon icon="InfoIcon" />
            Kayıtlı duyurunuz bulunmuyor.
          </div>
        </b-alert>
      </template>
      <template v-else>
        <limit-reached-card />
      </template>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCardBody, BButton, BTable, BCardFooter, BPagination, BAlert,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import LimitReachedCard from '@/layouts/components/common/limitReachedCard.vue'

const tableName = 'notifications'

export default {
  name: 'PageIndex',
  components: {
    LimitReachedCard,
    BAlert,
    BPagination,
    BCardFooter,
    ListButtons,
    BTable,
    BCard,
    BCardBody,
    BButton,
  },
  data() {
    return {
      currentPage: 1,
      userData: JSON.parse(localStorage.getItem('userData')),
      baseUrl: this.$store.state.app.baseURL,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'Başlık',
        },
        {
          key: 'sdate',
          label: 'Yayımlama',
        },
        {
          key: 'created',
          label: 'Düzenleme',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.created AS created`,
          `${tableName}.sdate AS sdate`,
          `${tableName}.edate AS edate`,
          `${tableName}.status AS status`,
          'users.name AS username',
          'categories.title AS categories',
          'products.title AS products',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['notifications/dataList']
    },
    dataCounts() {
      return this.$store.getters['notifications/dataCounts']
    },
    saveData() {
      return this.$store.getters['notifications/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success',
          title: 'İşlem Başarılı!',
          icon: 'CheckIcon',
          text: val.message,
        })
        this.getDataList()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger',
          title: 'İşlem Hatası!',
          icon: 'XIcon',
          text: val.message,
        })
        this.getDataList()
      }
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('notifications/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('notifications/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
